module.exports = __webpack_public_path__ + "static/media/defizap.4770feef.png";